const PublicContract = "0x938900d96d866237532D96Ab7ef6A5349BA60AE4";
const PresaleContract = "0x39c513B7f67f8F06B31e4A782c0C2e7De9005BA9";
const IDMContract = '0xB6923c415e67DB6467a653514c34a391ba91D7e1';
const WhiteContract = '0x317A1fe2Dbf67c7D038E4629393825B574B0e5f5';
const TokenContract = '0x7906407E6c7994e39DCBcaD723e6263600A1f232';
const LockContract = '0xdf88e186C34191065789400c86e981bD616466A4';


export { PresaleContract, LockContract, TokenContract, WhiteContract,IDMContract,PublicContract };